import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { logoutSpecific } from "../../../store/reducers/authReducer";
import { getUnAuthRedirectPath } from "../../../navigation/unAuthRedirect";

import { PopupForm, FlexRowBetween, Button, MyHr, RespFont } from "../Style";

const LogoutSpecipic = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const handleClose = () => {
    props.init(null);
  };
  const logout = () => {
    handleClose();
    dispatch(logoutSpecific()).then(() => {
      history.replace(getUnAuthRedirectPath());
    });
  };

  return (
    <PopupForm onClick={(e) => e.stopPropagation()}>
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "space-around",
        }}
      >
        <div style={{ width: "100%", marginTop: "30px" }}>
          <RespFont
            psize={"20px"}
            csize={"18px"}
            style={{
              textAlign: "center",
              marginBottom: "10px",
            }}
          >
            {"התנתקות"}
          </RespFont>
          <MyHr />
        </div>
        <div style={{ width: "100%", marginTop: "30px" }}>
          <RespFont style={{ textAlign: "center", marginBottom: "10px" }}>
            {"האם את/ה בטוח/ה שברצונך להתנתק?"}
          </RespFont>
          <MyHr />
        </div>
        <div style={{ width: "100%" }}>
          <FlexRowBetween style={{ width: "90%", margin: "20px auto" }}>
            <Button
              background={"rgba(123,150,196,0.95)"}
              style={{ padding: "9px 25px" }}
              onClick={logout}
            >
              כן
            </Button>
            <Button
              background={"rgba(41,59,90,0.95)"}
              style={{
                padding: "9px 25px",
              }}
              onClick={handleClose}
            >
              לא
            </Button>
          </FlexRowBetween>
        </div>
      </div>
    </PopupForm>
  );
};

export default LogoutSpecipic;
